import { FetchRequest, RequestInterceptor } from '@rails/request.js'

export const readCsrf = () => document.querySelector('meta[name="csrf-token"]')?.content || ''

export function applyCsrfToken(token) {
  if (!token) return
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta) meta.setAttribute('content', token)
  document.querySelectorAll('input[name="authenticity_token"]').forEach(el => (el.value = token))
  return token
}

export async function refreshCsrfToken() {
  const res = await fetch('/csrf', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
  if (!res.ok) throw new Error('csrf refresh failed')
  const { csrfToken } = await res.json()
  return applyCsrfToken(csrfToken)
}

// Interceptor runs BEFORE each request; ensure the latest token header.
// (Request.js includes X-CSRF-Token automatically, but this guarantees it’s the up-to-date meta value)
RequestInterceptor.register(request => {
  request.addHeader('X-CSRF-Token', readCsrf())
})

// Helper to clone FormData if you need to retry safely
function cloneFormData(fd) {
  if (!(fd instanceof FormData)) return fd
  const copy = new FormData()
  for (const [k, v] of fd.entries()) copy.append(k, v)
  return copy
}

// Perform a request and retry once on CSRF/session drift (401/403/422)
export async function performWithCsrfRetry(method, url, options = {}) {
  const original = { ...options, body: cloneFormData(options.body) }

  let req = new FetchRequest(method, url, original)
  let res = await req.perform()

  if (!res.ok && [401, 403, 422].includes(res.statusCode)) {
    try {
      await refreshCsrfToken()
      req = new FetchRequest(method, url, original)
      res = await req.perform()
    } catch {
      // last resort: hard-replace to sync head/session
      Turbo.visit(location.href, { action: 'replace' })
      throw new Error('CSRF refresh failed')
    }
  }
  return { request: req, response: res }
}
